import * as THREE from "three";
export class PlaneUtils {
    /**
     * @param {mesh} plane basic three.plane
     * @param {object} asset asset as given by the api
     * @param {object} coords coords to use
     * setup basic plane object
     */
    fnCreatePlane(plane, asset, coords, fMarkerWidth, fmarkerHeight) {
        plane.name = asset.name;
        plane.iBearId = asset.id;
        plane.isAsset = true;
        plane.isPlane = true;
        plane.visible = !asset.is_transparent;
        plane.originalAsset = asset;
        plane.position.set(
            coords.x - fMarkerWidth / 2 + coords.width / 2,
            -coords.y + fmarkerHeight / 2 - coords.height / 2,
            coords.z
        );
        plane.setRotationFromEuler(coords.euler);
    }
    fnCreateAlphaPlane(plane, asset, coords, texture, fMarkerWidth, fmarkerHeight) {
        this.fnCreatePlane(plane, asset, coords, fMarkerWidth, fmarkerHeight);

        const alphaVideoMaterial = new THREE.ShaderMaterial({
            transparent: true,
            fragmentShader: [
                "varying vec2 vUv;",
                "uniform sampler2D vidtexture;",
                "void main() {",
                "float v=vUv.y*0.5;",
                "vec4 alpha=texture2D(vidtexture, vec2(vUv.x,v));",
                "vec4 result = texture2D(vidtexture, vec2(vUv.x,0.5+v));",
                "result.a=alpha.r;",
                "gl_FragColor = result;",
                "}"
            ].join("\n"),
            vertexShader: [
                "varying vec2 vUv;",
                "void main() {",
                "vUv            =   uv;",
                "gl_PointSize   =   8.0;",
                "gl_Position    =   projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
                "}"
            ].join("\n"),
            uniforms: {
                vidtexture: { value: texture }
            }
        });

        plane.alphavideo = true;
        plane.material = alphaVideoMaterial;
        plane.texture = texture;
    }

    /**
     * Modify plane with shader for green background video. To do : Vertex shader should be in common with fnCreateAlphaPlane
     *
     * @param {plane} a Threejs plane
     * @param {asset} the origin asset
     * @param {coords} a asset coordinates
     * @param {texture} a Three js video texture
     * @param {greenColor} the color in scene description which should be made transparent
     */
    fnCreateGreenPlane(plane, asset, coords, texture, greenColor, fMarkerWidth, fmarkerHeight) {
        this.fnCreatePlane(plane, asset, coords, fMarkerWidth, fmarkerHeight);
        let hex = Number(greenColor).toString(16);
        if (hex.length < 6) {
            hex = "0" + hex;
        }
        const r = parseInt(hex.substr(0, 2), 16) / 255.0;
        const g = parseInt(hex.substr(2, 2), 16) / 255.0;
        const b = parseInt(hex.substr(4, 2), 16) / 255.0;
        const alphaVideoMaterial = new THREE.ShaderMaterial({
            fragmentShader: [
                "vec3 rgb2hsv(vec3 c)",
                "{",
                "vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);",
                "vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));",
                "vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));",
                "float d = q.x - min(q.w, q.y);",
                "float e = 1.0e-10;",
                "return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);",
                "}",
                "float chromaKey(vec3 rgb,vec3 backgroundColor)",
                "{",
                "vec3 weights = vec3(4., 1., 2.0);",
                "vec3 hsv = rgb2hsv(rgb);",
                "vec3 bhsv = rgb2hsv(backgroundColor);",
                "float dist = length(weights * (bhsv - hsv));",
                "return  clamp(dist*6.0-3.0, 0., 1.);",
                "}",
                "vec3 changeSaturation(vec3 color, float saturation)",
                "{",
                "float luma = dot(vec3(0.213, 0.715, 0.072) * color, vec3(1.));",
                "return mix(vec3(luma), color, saturation);",
                "}",
                "uniform sampler2D vidtexture;",
                "uniform vec3 color;",
                "varying vec2 vUv;",
                "void main(void)",
                "{",
                "vec3 tColor = texture2D( vidtexture, vUv ).rgb;",
                "float incrustation = chromaKey(tColor,color);",
                "if ( incrustation< 0.10 ) discard;",
                "gl_FragColor = vec4(tColor, incrustation);",
                "}"
            ].join("\n"),
            vertexShader: [
                "varying vec2 vUv;",
                "void main() {",
                "vUv            =   uv;",
                "gl_PointSize   =   8.0;",
                "gl_Position    =   projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
                "}"
            ].join("\n"),
            uniforms: {
                vidtexture: { value: texture },
                color: { value: new THREE.Vector3(r, g, b) }
            }
        });

        plane.alphavideo = true;
        plane.material = alphaVideoMaterial;
        plane.texture = texture;
    }
}
